import PortletAttachment from "./PortletAttachment.js";
import React, { Component } from "react";
import { connect } from "react-redux";
import shortid from "shortid";
import axios from "../../AxiosClient";
import PubSub from "pubsub-js";
import { PORTLET_ATTACHMENT_ADD } from "../../utils/Topics";

export class CorePortletAttachments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: [],
      message: {},
      instance: shortid.generate(),
    };
  }
  componentDidMount() {
    this.token = PubSub.subscribe(PORTLET_ATTACHMENT_ADD, this.subscriber);
    this.setState({ attachments: this.props.portlet.attachments });
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.token);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isPortlet && this.props.portlet !== prevProps.portlet) {
      this.setState({ attachments: this.props.portlet.attachments });
    }
  }

  subscriber = (msg, data) => {
    if (data.portletId === this.props.portlet.id) {
      let attachments = [...this.state.attachments];
      attachments.push(data.attachment);
      this.setState({ attachments });
    }
  };

  render() {
    return (
      <>
        {this.state.attachments
          ? this.state.attachments.map(
              (attachment) =>
                this.props.top === attachment.top ? (
                  <PortletAttachment
                    onAttachmentDelete={this.onAttachmentDelete}
                    onAttachmentUpdate={this.onAttachmentUpdate}
                    attachmentInstance={this.state.instance}
                    key={attachment.id}
                    portlet={this.props.portlet}
                    attachment={attachment}
                  />
                ) : null
            )
          : null}
      </>
    );
  }

  onAttachmentDelete = (id) => {
    let attachments = [...this.state.attachments];
    this.state.attachments.forEach((attachment, index) => {
      if (attachment.id === id) {
        attachments.splice(index, 1);
      }
    });
    this.setState({ attachments: attachments });
  };

  onAttachmentUpdate = (newAttachment) => {
    let attachments = [...this.state.attachments];
    for (let i = 0; i < attachments.length; i++) {
      if (attachments[i].id === newAttachment.id) {
        attachments[i] = newAttachment;
      }
    }
    this.setState({ attachments });
  };
}
const mapStateToProps = (state) => ({
  portalLayout: state.layout.currentLayout,
});
export default connect(
  mapStateToProps,
  null
)(CorePortletAttachments);
